var map = {
	"./bg-BG/core": [
		809,
		809
	],
	"./cs-CZ/core": [
		5451,
		451
	],
	"./da-DK/core": [
		7741,
		741
	],
	"./de-DE/core": [
		3111,
		111
	],
	"./en-US/core": [
		1497
	],
	"./es-ES/core": [
		257,
		257
	],
	"./fa-IR/core": [
		4764,
		764
	],
	"./fr-FR/core": [
		5412,
		412
	],
	"./hu-HU/core": [
		550,
		550
	],
	"./id-ID/core": [
		8673,
		673
	],
	"./it-IT/core": [
		7315,
		315
	],
	"./ja-JP/core": [
		3447,
		447
	],
	"./ko-KR/core": [
		3931,
		312
	],
	"./nl-NL/core": [
		6439,
		439
	],
	"./pl-PL/core": [
		6422,
		422
	],
	"./pt-BR/core": [
		3715,
		715
	],
	"./ro-RO/core": [
		9715,
		96
	],
	"./ru-RU/core": [
		9557,
		557
	],
	"./sk-SK/core": [
		686,
		686
	],
	"./sv-SE/core": [
		7023,
		23
	],
	"./tr-TR/core": [
		9190,
		190
	],
	"./uk-UA/core": [
		8312,
		931
	],
	"./uz-UZ/core": [
		1409,
		409
	],
	"./zh-CN/core": [
		5239,
		239
	],
	"./zh-TW/core": [
		5352,
		352
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;